import React, {useEffect, useMemo, useState} from 'react';
import {Breadcrumb, Button, Card, Checkbox, InputNumber, message, Modal, PageHeader, Popover, Select, Space, Table, Typography} from 'antd';
import useCollectionWork from '../../../hooks/apis/useCollectionWork';
import QuickRouter from '../../../utils/QuickRouter';
import Flex from '../../../components/Flex';
import CollectionWorkProjectRecordList from '../../../components/CollectionWorkProjectRecord/List';
import UseCollectionWorkProject from '../../../hooks/apis/useCollectionWorkProject';
import Text from 'antd/lib/typography/Text';
import UseCollectionWorkProjectRecord, {ICollectionWorkProjectRecord} from '../../../hooks/apis/useCollectionWorkProjectRecord';
import {UserType} from '../../../hooks/apis/useUser';
import {useBoolean} from 'react-hanger';
import CustomerError from '../../../components/CustomerError';
import useAuth from '../../../utils/AuthContext';
import {useParams} from 'react-router-dom';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';

export default function CollectionWorkReviewPage() {
  const params = useParams() as {id?: string};
  const collectionWorkId = parseInt(params.id as string);
  const collectionWorkState = useCollectionWork.queryById();
  const projectListState = UseCollectionWorkProject.list();
  const listRecord = UseCollectionWorkProjectRecord.list();
  const download = UseCollectionWorkProjectRecord.download();
  const listScoreState = UseCollectionWorkProject.listScore();
  const review = UseCollectionWorkProjectRecord.review();
  const [projectId, setProjectId] = useState<number>();
  const [score, setScore] = useState<number>(0);
  const onlyNotScore = useBoolean(false);
  const auth = useAuth();
  const quickRouter = useQuickRouter();

  function refresh() {
    collectionWorkState
      .request({id: collectionWorkId})
      .then(res => {
        projectListState
          .request({collectionWorkId: res.id})
          .then(res => {
            setProjectId(res[0].id);
          })
          .catch(CommonApiErrorHandler);
        listRecord.request({collectionWorkId: res.id});
      })
      .catch(CommonApiErrorHandler);
  }

  function refreshScoreList() {
    listScoreState
      .request({projectId, reviewerId: auth.currentUser?.id})
      .then()
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    if (collectionWorkId) {
      refresh();
    }
  }, [collectionWorkId]);

  useEffect(() => {
    refreshScoreList();
  }, [projectId]);

  const recordList = useMemo(() => {
    return (
      listRecord.data
        ?.filter(i => i.collectionWorkProjectId === projectId)

        .map(i => {
          const existScore = listScoreState.data?.find(s => s.collectionWorkProjectRecordId === i.id);
          return {
            ...i,
            score: existScore?.score || 0,
            reviewTime: existScore?.reviewTime,
          };
        })
        .filter(i => {
          if (!onlyNotScore.value) return true;
          return !i.reviewTime;
        }) || []
    );
  }, [listRecord.data, listScoreState.data, onlyNotScore.value]);
  if (!auth.currentUser || auth.currentUser.type !== UserType.评审员) return <CustomerError title={'无操作权限'} />;

  return (
    <Flex justify={'center'}>
      <div style={{width: 900}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(collectionWorkState.data?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card title={'作品评审'}>
          <Space className={'mb-md'}>
            <Text>筛选项目:</Text>
            <Select style={{width: 200}} value={projectId} onChange={e => setProjectId(e)}>
              {projectListState.data?.map(project => (
                <Select.Option key={project.id} value={project.id}>
                  {project.name}
                </Select.Option>
              ))}
            </Select>
            <Checkbox checked={onlyNotScore.value} onChange={e => onlyNotScore.setValue(e.target.checked)}>
              只显示未评分
            </Checkbox>
          </Space>
          <Table bordered dataSource={recordList} rowKey={'id'} size={'small'}>
            <Table.Column<ICollectionWorkProjectRecord> title="参评项目" width={100} dataIndex={['collectionWorkProject', 'name']} />
            <Table.Column<ICollectionWorkProjectRecord> title="作品名称" width={100} dataIndex="name" />
            <Table.Column<ICollectionWorkProjectRecord> title="学生姓名" width={150} dataIndex={['user', 'legalName']} />
            <Table.Column<ICollectionWorkProjectRecord>
              width={90}
              title="文件大小"
              dataIndex={['fileRecord', 'sizeMb']}
              render={(_, row) => <Typography.Text>{_.toFixed(2)} Mb</Typography.Text>}
            />
            <Table.Column<any> title="评分" width={120} render={(_, item) => (item?.reviewTime ? item.score : '未评分')} />
            <Table.Column<ICollectionWorkProjectRecord>
              width={100}
              title="操作"
              render={(_, row) => (
                <Space>
                  <a
                    onClick={() => {
                      download
                        .request({id: row.id})
                        .then(res => {
                          window.open(res.fileRecord?.url, '_blank');
                        })
                        .catch(CommonApiErrorHandler);
                    }}>
                    下载文件
                  </a>
                  <Popover
                    title={'评分'}
                    trigger={'click'}
                    content={
                      <Space>
                        <span>请输入分数:</span>
                        <InputNumber value={score} onChange={setScore as any} min={0} max={row?.collectionWorkProject?.maxScore || 100} />
                        <Button
                          onClick={() =>
                            review
                              .request({id: row.id, score})
                              .then(refreshScoreList)
                              .catch(CommonApiErrorHandler)
                          }
                          loading={review.loading}>
                          保存
                        </Button>
                      </Space>
                    }>
                    <a>评分</a>
                  </Popover>
                </Space>
              )}
            />
          </Table>
        </Card>
      </div>
    </Flex>
  );
}
